import { CURRENT_GTC_VERSIONS, type GtcType } from "constants/gtc";

const GTC_APPROVAL_PREFIX = "gtc_approval_";

export const gtcApprovalStorageKey = (accountId: string, gtcType: GtcType) =>
  `${GTC_APPROVAL_PREFIX}${accountId}_${gtcType}_${CURRENT_GTC_VERSIONS[gtcType]}`;

export const hasPersistedGtcApproval = (
  accountId: string,
  gtcType: GtcType,
): boolean =>
  localStorage.getItem(gtcApprovalStorageKey(accountId, gtcType)) === "true";

export const persistGtcApproval = (
  accountId: string,
  gtcType: GtcType,
): void => {
  localStorage.setItem(gtcApprovalStorageKey(accountId, gtcType), "true");
};
